import type { EnterpriseAcronymEntry } from '../types/project';

function stripListPrefix(value: string): string {
  return value.replace(/^\s*(?:[-*]|\u2022|\d+[.)])\s+/, '').trim();
}

function splitAcronymLine(value: string): { term: string; definition: string } {
  const match = value.match(/[:=\t,]|\s[-\u2013\u2014]\s/);
  if (match && match.index && match.index > 0) {
    return {
      term: value.slice(0, match.index).trim(),
      definition: value.slice(match.index + match[0].length).trim(),
    };
  }

  const whitespace = value.search(/\s+/);
  if (whitespace > 0) {
    return {
      term: value.slice(0, whitespace).trim(),
      definition: value.slice(whitespace).trim(),
    };
  }

  const term = value.trim();
  return { term, definition: term };
}

export function parseEnterpriseAcronymsText(raw: string): EnterpriseAcronymEntry[] {
  const entries: EnterpriseAcronymEntry[] = [];
  const seen = new Set<string>();

  raw
    .split(/\r?\n/)
    .map(stripListPrefix)
    .filter(Boolean)
    .forEach((line) => {
      const contextIndex = line.indexOf('|');
      const base = contextIndex >= 0 ? line.slice(0, contextIndex).trim() : line;
      const context = contextIndex >= 0 ? line.slice(contextIndex + 1).trim() : '';
      const parsed = splitAcronymLine(base);
      const term = parsed.term.replace(/^["']|["']$/g, '').trim();
      const definition = parsed.definition.replace(/^["']|["']$/g, '').trim();

      if (!term || !definition) return;

      const key = `${term.toLowerCase()}|${definition.toLowerCase()}|${context.toLowerCase()}`;
      if (seen.has(key)) return;
      seen.add(key);

      entries.push({
        term,
        definition,
        ...(context ? { context } : {}),
      });
    });

  return entries;
}

export function serializeEnterpriseAcronyms(entries: EnterpriseAcronymEntry[]): string {
  return entries
    .map((entry) => {
      const base = `${entry.term}: ${entry.definition}`;
      return entry.context ? `${base} | ${entry.context}` : base;
    })
    .join('\n');
}
